import React from 'react'
import {Provider} from '../context/Context';
import Grid, {kGridNews} from "../components/Grid";

const NewsTemplate = (props) => {

    return (
        <Provider router={props}>
            <Grid filter={kGridNews}/>
        </Provider>
    )

};

export default NewsTemplate